namespace ekh {
    angular
        .module('ekh')
        .directive('emailMyQuote', function($routeParams, tripService, quoteManager, resourceService, authService) {
            return {
                restrict: 'E',
                replace: true,
                templateUrl: 'partials/home/directivetemplate?type=emailmyquote',
                controllerAs: 'emq',
                bindToController: true,
                scope: {},
                link: ($scope) => {
                    $scope.formState.setSubmitFn(data => {
                        return quoteManager.create(data);
                    });
                },
                controller($scope) {
                    this.salutationOptions = resourceService.getDeferred('EMAILQUOTESALUTATIONOPTIONS');
                    this.customer = {};
                    this.isSkywardsUser = false;
                    this.user = authService.getUser();
                    this.isSendEmailToSelfEnabled = false;

                    this.processCustomerDetails = (bindWithSkywards) => {
                        if (bindWithSkywards) {
                            this.customer = {
                                title: this.user.Title || '',
                                quoteSignupEmail: this.user.Email || '',
                                firstName: this.user.FirstName || '',
                                lastName: this.user.LastName || '',
                                mobileTel: ''
                            };
                        } else {
                            this.customer = {};
                        }
                    };

                    this.checkSkywardsUser = () => {
                        if (this.user && this.user.HardSignedIn) {
                            this.isSkywardsUser = true;
                            this.isSendEmailToSelfEnabled = true;
                            this.processCustomerDetails(this.isSkywardsUser);
                        } else {
                            this.isSkywardsUser = false;
                            this.isSendEmailToSelfEnabled = false;
                            this.processCustomerDetails(this.isSkywardsUser);
                        }
                    };
                    this.checkSkywardsUser();

                    this.toggleSendEmailToSelfOption = () => {
                        this.processCustomerDetails(this.isSendEmailToSelfEnabled);
                        $scope.formState.resetSubmitResult();
                    };

                    this.submit = async (customer, shouldSignUp) => {
                        const trip = await tripService.getTrip($routeParams.tripId);
                        const request = {
                            BasketId: trip.BasketId,
                            QuoteId: '',
                            EmailAddress: customer.quoteSignupEmail,
                            EmailSignUp: shouldSignUp,
                            User: {
                                Title: customer.title || '',
                                FirstName: customer.firstName,
                                LastName: customer.lastName,
                                Email: customer.quoteSignupEmail,
                                MobileTel: ''
                            },
                            TrackingTag: null,
                            SendEmail: true,
                            SharedUse: true,
                            SkywardsTotalMiles: (TRPCONFIG.Domain.SkywardsInfo &&
                                TRPCONFIG.Domain.SkywardsInfo.length > 0 &&
                                TRPCONFIG.Domain.SkywardsInfo[0].Miles > 0) ?
                                TRPCONFIG.Domain.SkywardsInfo[0].Miles : null
                        };

                        $scope.formState.resetSubmitResult();
                        return $scope.formState.submit(request);
                    };
                }
            };
        });
}
